module.exports = __webpack_public_path__ + "img/thumbnail_SouthernWhiteRhino_f_normal.8ee3130f.png";